// extracted by mini-css-extract-plugin
module.exports = {"container":"_3DTATrFhiMQSnVt3XaAcX0","complianceCopy":"_1A8QKcecYPMcyoqH-oL433","complianceImage":"_1fY52x3CasRDqH9n-cJaeV"};